import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	Box,
	Grid
} from '@mui/material';
import { LogOut, AlertTriangle, MessageSquare, Settings } from 'lucide-react';
import { AlertInfo } from '../../components/Alerts/Alert';
import { api, whatsappWEbApi } from '../../services/api';
import { WhatsAppConnection } from './whatsappTypes';
import moment from 'moment';

interface DisconnectWhatsAppProps {
	connection: WhatsAppConnection;
	onDisconnect: () => void;
	loading: (flag: boolean) => void;
}

const DisconnectWhatsApp: React.FC<DisconnectWhatsAppProps> = ({ onDisconnect, loading, connection }) => {
	const [dialogOpen, setDialogOpen] = useState(false);

	async function upConnection() {
		try {
			const { session_id } = connection;
			const data = { session_id, is_connected: 0, disconnect_at: moment().format('YYYY-MM-DD HH:mm:ss') }
			await api.post(`/updatewhatsapp`, data);
		} catch (error) {
			console.log(error);
		}
	}

	const handleDisconnect = async () => {
		loading(true);
		try {
			const response = await whatsappWEbApi.delete(`/whatsapp/disconnect/${connection.session_id}`);
			console.log(response);
			if (response && response.data && response.data.success) {
				await upConnection();
				AlertInfo({ icon: 'success', title: 'Whatsapp Disconectado' });
				setDialogOpen(false);
				onDisconnect();
			}
		} catch (error) {
			console.log(error);
			AlertInfo({ icon: 'error', title: 'Falha na conexão' });
		}
		loading(false);
	};

	return (
		<>
			<Grid container spacing={1} justifyContent="space-between">
				<Grid item xs={12} sm={3}>
					<Button
						variant="outlined"
						color="error"
						startIcon={<LogOut size={18} />}
						onClick={() => setDialogOpen(true)}
						sx={{ mt: 2 }}
						fullWidth
					>
						Desconectar WhatsApp
					</Button>
				</Grid>
				<Grid item xs={12} sm={3}>
					<Link to="/mensagens">
						<Button
							variant="outlined"
							color="primary"
							startIcon={<MessageSquare size={18} />}
							sx={{ mt: 2 }}
							fullWidth
						>
							HISTORICO DE MENSAGENS
						</Button>
					</Link>
				</Grid>
				<Grid item xs={12} sm={3}>
					<Link to="/configmessage">
						<Button
							variant="outlined"
							color="primary"
							startIcon={<Settings size={18} />}
							sx={{ mt: 2 }}
							fullWidth
						>
							CONFIGURAR MENSAGENS
						</Button>
					</Link>
				</Grid>
			</Grid>

			<Dialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				maxWidth="xs"
				fullWidth
			>
				<DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
					Disconnect WhatsApp
				</DialogTitle>

				<DialogContent>
					<Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
						<Box sx={{
							backgroundColor: '#FFEBEE',
							p: 2,
							borderRadius: '50%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center'
						}}>
							<AlertTriangle size={32} color="#F44336" />
						</Box>
					</Box>

					<Typography variant="body1" sx={{ textAlign: 'center', mb: 1 }}>
						Tem certeza de que deseja desconectar sua conta do WhatsApp?
					</Typography>

					<Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
						Você não poderá enviar mensagens por meio desta plataforma.
					</Typography>
				</DialogContent>

				<DialogActions sx={{ justifyContent: 'center', p: 3 }}>
					<Button
						onClick={() => setDialogOpen(false)}
						color="inherit"
						sx={{ mr: 1 }}
					>
						Cancelar
					</Button>
					<Button
						onClick={handleDisconnect}
						variant="contained"
						color="error"
					>
						Desconectar
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default DisconnectWhatsApp;